"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const coamCache = require("./coam-cache");
const coamProxy = require("./coam-proxy");
const logger_1 = require("./helpers/logger");
async function getResourceTypePermissions(resourceType, principal, authorization, correlationId) {
    return coamProxy.readResourceTypePermissions(resourceType, principal, authorization, correlationId);
}
exports.getResourceTypePermissions = getResourceTypePermissions;
async function getResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId) {
    const cacheKey = getCacheKey(resourceIdentifier, resourceType, principal);
    const cached = coamCache.readResourcePermissions(cacheKey);
    if (cached) {
        if (coamCache.shouldRefreshCache(cacheKey)) {
            logger_1.getLogger().info({ correlationId }, `Updating COAM cache with age ${Math.round(coamCache.getAgeInSeconds(cacheKey))}s.`);
            // intentionally not awaited:
            readResourcePermissionsFromProxyAndCache(resourceIdentifier, resourceType, principal, authorization, correlationId).catch(err => logger_1.getLogger().warn({ correlationId, err }, 'Unable to cache COAM Result'));
        }
        return cached;
    }
    logger_1.getLogger().info({ correlationId }, 'COAM data not found in local cache, calling COAM');
    return readResourcePermissionsFromProxyAndCache(resourceIdentifier, resourceType, principal, authorization, correlationId);
}
exports.getResourcePermissions = getResourcePermissions;
async function readResourcePermissionsFromProxyAndCache(resourceIdentifier, resourceType, principal, authorization, correlationId) {
    const resources = await coamProxy.readResourcePermissions(resourceIdentifier, resourceType, principal, authorization, correlationId);
    const cacheKey = getCacheKey(resourceIdentifier, resourceType, principal);
    coamCache.cacheResourcePermissions(cacheKey, resources);
    return resources;
}
function getCacheKey(resourceIdentifier, resourceType, principal) {
    return `${resourceIdentifier}@${resourceType}@${principal}`;
}
exports.getCacheKey = getCacheKey;
//# sourceMappingURL=coam-repository.js.map